namespace $ {
	export type $shm_hotkey_binding = { code: string, ctrl: boolean, alt: boolean, shift: boolean, meta: boolean }
	export function $shm_hotkey_chord( key: $shm_hotkey_binding ) {
		return [ key.ctrl ? 'Ctrl' : '', key.alt ? 'Alt' : '', key.shift ? 'Shift' : '', key.meta ? 'Meta' : '', key.code ].filter( Boolean ).join( '+' )
	}
	export function $shm_hotkey_label( key: $shm_hotkey_binding ) {
		return $shm_hotkey_chord( key ).replace( /Key([A-Z])$/, '$1' ).replace( /Digit(\d)$/, '$1' )
	}
	export function $shm_hotkey_binding_from( event: KeyboardEvent ): $shm_hotkey_binding | null {
		if( !event.code || /^(?:Shift|Control|Alt|Meta|OS)|^(?:Escape|Tab|CapsLock|Unidentified)$/.test( event.code ) ) return null
		return { code: event.code, ctrl: event.ctrlKey, alt: event.altKey, shift: event.shiftKey, meta: event.metaKey }
	}
	export class $shm_hotkey_model extends $mol_object {
		scope() { return 'default' }
		@ $mol_mem
		bindings( next?: Record< string, $shm_hotkey_binding > ) {
			const value = this.$.$mol_state_local.value< Record< string, $shm_hotkey_binding > >( `shm_hotkey:${ this.scope() }:bindings`, next ) ?? {}
			return Object.fromEntries( Object.entries( value ).filter( ([ id, key ])=> id && key && typeof key.code === 'string' && /^[\w]+$/.test( key.code ) && [ key.ctrl, key.alt, key.shift, key.meta ].every( flag => typeof flag === 'boolean' ) ) )
		}
		@ $mol_mem
		activation( next?: string ) {
			return this.$.$mol_state_local.value< string >( `shm_hotkey:${ this.scope() }:activation`, next ) || 'KeyC'
		}
		@ $mol_mem
		index() { return new Map( Object.entries( this.bindings() ).map( ([ id, key ])=> [ $shm_hotkey_chord( key ), id ] ) ) }
		@ $mol_action
		assign( id: string, key: $shm_hotkey_binding ) {
			const owner = this.index().get( $shm_hotkey_chord( key ) )
			if( owner && owner !== id ) return 'Это сочетание уже назначено другой кнопке.'
			if( key.code === this.activation() && !key.ctrl && !key.alt && !key.shift && !key.meta ) return 'Это клавиша назначения. Выберите другую.'
			this.bindings({ ... this.bindings(), [ id ]: key })
			return ''
		}
		@ $mol_action
		remove( id: string ) {
			const next = { ... this.bindings() }
			delete next[ id ]
			this.bindings( next )
		}
	}
}
